import { Component, Input } from "@angular/core";
import { ItemInfoComponent } from "@ponder-shared/components/item-info.component";

@Component({
    selector: "search-info",
    imports: [],
    templateUrl: "./search-info.component.html"
})
export class SearchInfoComponent extends ItemInfoComponent {
    @Input({ required: true }) searchTerm!: string;
}